import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const CubeSecurityContext = { id: 11, name: 'Cube Security Context' };
export const dataConnectionDatabaseName = defineFeature({
    type: FeatureType.String,
    propName: 'data_connection_database_name',
    uiName: 'dataConnectionDatabaseName',
    displayName: 'Database Name',
    description: 'Database name used for Cube security context.',
    category: CubeSecurityContext,
    areas: ['data-connection'],
    applicability: {
        providers: ['CUBEJS'],
    },
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const dataConnectionSchemaName = defineFeature({
    type: FeatureType.String,
    propName: 'data_connection_schema_name',
    uiName: 'dataConnectionSchemaName',
    displayName: 'Schema Name',
    description: 'Schema name used for Cube security context.',
    category: CubeSecurityContext,
    areas: ['data-connection'],
    applicability: {
        providers: ['CUBEJS'],
    },
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const cubeSecurityContextFeatures = [
    dataConnectionDatabaseName,
    dataConnectionSchemaName,
];
